import React from 'react';
import Header from './Header';
import { Outlet } from 'react-router-dom';
import { Heart, Github, Linkedin, Twitter } from 'lucide-react';
const MainLayout = () => {
  return (
    <div className="min-h-screen transition-colors duration-500 relative">
      {/* Floating Decorative Orbs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" aria-hidden="true">
        <div className="floating-orb w-[600px] h-[600px] bg-indigo-400 dark:bg-indigo-600 -top-[200px] -left-[200px] animate-float-slow" />
        <div className="floating-orb w-[500px] h-[500px] bg-purple-400 dark:bg-purple-600 -bottom-[150px] -right-[150px] animate-float" style={{ animationDelay: '2s' }} />
        <div className="floating-orb w-[300px] h-[300px] bg-pink-300 dark:bg-pink-600 top-1/2 left-1/3 animate-float-slow" style={{ animationDelay: '4s' }} />
        <div className="floating-orb w-[200px] h-[200px] bg-cyan-300 dark:bg-cyan-600 top-1/4 right-1/4 animate-float" style={{ animationDelay: '1s' }} />
      </div>

      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 relative z-10">
        <div className="animate-fade-in-up">
          <Outlet />
        </div>
      </main>

      {/* Premium Footer */}
      <footer className="relative z-10 mt-16 border-t border-gray-200/50 dark:border-gray-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8">
            {/* Brand */}
            <div className="flex flex-col items-center md:items-start gap-2">
              <h3 className="text-xl font-bold font-display neon-text">PrepMaster</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400 max-w-xs text-center md:text-left">
                Your ultimate companion for placement preparation. Master DSA, conquer aptitude, land your dream job.
              </p>
            </div>

            {/* Links */}
            <div className="flex items-center gap-6">
              <FooterLink href="https://github.com" icon={<Github className="w-5 h-5" />} label="GitHub" />
              <FooterLink href="https://linkedin.com" icon={<Linkedin className="w-5 h-5" />} label="LinkedIn" />
              <FooterLink href="https://twitter.com" icon={<Twitter className="w-5 h-5" />} label="Twitter" />
            </div>
          </div>

          {/* Divider */}
          <div className="mt-8 pt-6 border-t border-gray-200/30 dark:border-gray-800/30 text-center">
            <p className="text-xs text-gray-400 dark:text-gray-500 flex items-center justify-center gap-1">
              Built with <Heart className="w-3 h-3 text-rose-500 fill-rose-500 animate-pulse" /> by PrepMaster Team © {new Date().getFullYear()}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

const FooterLink = ({ href, icon, label }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    className="w-10 h-10 rounded-xl bg-gray-100 dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400 hover:text-indigo-500 dark:hover:text-indigo-400 hover:border-indigo-300 dark:hover:border-indigo-700 hover:shadow-neon-indigo transition-all duration-300 hover:-translate-y-0.5"
  >
    {icon}
  </a>
);

export default MainLayout;
